export function errMessage(err, fallback = "Please try again.") {
  const d = err?.response?.data?.detail;
  if (typeof d === "string" && d) return d;
  if (Array.isArray(d)) {
    const msgs = d.map((x) => (typeof x === "string" ? x : x?.msg)).filter(Boolean);
    if (msgs.length) return msgs.join(" · ");
  }
  return err?.message || fallback;
}
